import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  ShipmentSpecialFreightItemNotificationListCountLoad,
  ShipmentSpecialFreightItemSetIdentifier,
  ShipmentSpecialFreightItemSetInitial,
} from './shipment-special-freight-item.actions';
import { SpecialFreightIdView } from '../../../models';
import { Observable, of } from 'rxjs';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { catchError, map } from 'rxjs/operators';
import { CustomHttpErrorResponse, Error } from '../../../../common/constants/error';
import { NotificationService } from '../../../../common';
import { ShipmentSpecialFreightItemService } from './shipment-special-freight-item.service';

export interface ShipmentSpecialFreightItemStateModel {
  shipmentSpecialFreightIdentifier: SpecialFreightIdView;
  notificationListCount: number;
  loaded: boolean;
}

const initialState: ShipmentSpecialFreightItemStateModel = {
  shipmentSpecialFreightIdentifier: null,
  notificationListCount: null,
  loaded: false,
};

@State<ShipmentSpecialFreightItemStateModel>({
  name: 'shipmentSpecialFreightIdentifier',
  defaults: initialState,
})
@Injectable()
export class ShipmentSpecialFreightItemState {
  @Selector()
  static getState(state: ShipmentSpecialFreightItemStateModel): ShipmentSpecialFreightItemStateModel {
    return state;
  }

  @Selector()
  static getSpecialFreightIdentifier(state: ShipmentSpecialFreightItemStateModel): SpecialFreightIdView {
    return state.shipmentSpecialFreightIdentifier;
  }

  @Selector()
  static getSpecialFreightNotificationListCount(state: ShipmentSpecialFreightItemStateModel): number {
    return state.notificationListCount;
  }

  @Selector()
  static getLoaded(state: ShipmentSpecialFreightItemStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private shipmentSpecialFreightItemService: ShipmentSpecialFreightItemService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentSpecialFreightItemSetIdentifier)
  setShipmentSpecialFreightIdentifier(
    ctx: StateContext<ShipmentSpecialFreightItemStateModel>,
    { payload }: ShipmentSpecialFreightItemSetIdentifier,
  ): void {
    ctx.patchState({ ...ctx.getState(), shipmentSpecialFreightIdentifier: payload });
  }

  @Action(ShipmentSpecialFreightItemNotificationListCountLoad)
  getSpecialFreightNotificationListCount(
    ctx: StateContext<ShipmentSpecialFreightItemStateModel>,
    { payload }: ShipmentSpecialFreightItemNotificationListCountLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentSpecialFreightItemService.getNotificationListCount(payload).pipe(
      map((notificationListCount: number) => {
        ctx.patchState({ ...ctx.getState(), notificationListCount, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentSpecialFreightItemSetInitial)
  setInitialState(ctx: StateContext<ShipmentSpecialFreightItemStateModel>): void {
    ctx.setState(initialState);
  }
}
